<template>
  <div id="admin-occupation-edit">
    <!-- 编辑职业技能鉴定考核界面 -->
    <div class="content" v-loading="loading">
      <div class="goback" @click="goback">
        <i class="el-icon-d-arrow-left"></i>返回
      </div>
      <div class="con">
        <div
          :class="{
            line: true,
            'style-line-1': item.style == '1',
            'style-line-2': item.style == '2',
          }"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="title">
            <span class="xx" v-if="item.isNotNull">*</span>{{ item.title }}
            <span v-if="item.type == 'input-num-precent'">(%)</span>
          </div>
          <div
            class="value"
            v-if="
              item.type == 'input' ||
              item.type == 'input-num' ||
              item.type == 'input-num-precent'
            "
          >
            <el-input
              v-model="item.value"
              :placeholder="'请输入' + item.title"
              clearable
            ></el-input>
          </div>
          <div class="value" v-if="item.type == 'select'">
            <el-select
              v-model="item.value"
              :placeholder="'请选择' + item.title"
              clearable
            >
              <el-option
                v-for="(it, ii) in item.options"
                :key="ii"
                :label="it.label"
                :value="it.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="value" v-if="item.type == 'select-disable'">
            <el-select
              v-model="item.value"
              :placeholder="'请选择' + item.title"
              clearable
            >
              <el-option
                v-for="(it, ii) in item.options"
                :key="ii"
                :label="it.label"
                :value="it.value"
                :disabled="it.flag"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="line">
          <div class="title"></div>
          <div class="add_but" @click="submit">
            <i class="el-icon-check"></i> 提交
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as workLicenseData from "./js/occupationStation.js";
export default {
  data() {
    return {
      loading: false,
      id: "",
      options: {
        professionalId: [], // 专业
        station: [], // 工种/岗位
        examId: [], // 考试列表
      },
      list: workLicenseData.getEditData(),
    };
  },
  methods: {
    /**
     * 获取专业下拉框数据
     */
    async getProfessionalList() {
      try {
        let resultData = await this.$request({
          url: "/professional/getProfessionalList",
          method: "post",
          data: { name: "" },
        });
        this.options.professionalId = [];
        resultData.forEach((element) => {
          let dd = {
            label: element.name,
            value: element.id,
          };
          this.options.professionalId.push(dd);
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 获取职业技能等级下拉框数据
     */
    async getListByType() {
      try {
        let resultData = await this.$request({
          url: "/occupationStation/getStationForSelect",
          method: "post",
          data: { name: "" },
        });
        this.options.station = [];
        resultData.forEach((element) => {
          let dd = {
            label: element.name,
            value: element.id,
          };
          this.options.station.push(dd);
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 获取考试下拉框数据
     */
    async reExamList() {
      try {
        let resultData = await this.$request({
          url: "/exam/reExamList",
          method: "post",
          data: { type: "station" },
        });
        this.options.examId = [];
        resultData.forEach((element) => {
          let dd = {
            label: element.name,
            value: element.id,
            flag: element.flag,
          };
          this.options.examId.push(dd);
        });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 获取职业技能等级考核详情
     */
    async initData() {
      try {
        let resultData = await this.$request({
          url: "/occupation/showOccupationDetails",
          method: "post",
          data: { id: this.id },
        });
        this.list = this.$baseData.json2array(this.list, resultData);
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 手动提交
     */
    async submit() {
      if (await this.saveWorkLicenseTask()) {
        this.$message({
          message: "操作成功!",
          type: "success",
          duration: 500,
        });
        this.$router.back();
      }
    },
    /**
     * 提交上岗证考核任务
     */
    async saveWorkLicenseTask() {
      try {
        this.list.forEach((element) => {
          // 1.非空判断
          if (element.isNotNull && element.value == "") {
            throw { message: element.title + "不能为空!" };
          }
          // 2.数字判断
          if (
            element.type == "input-num" &&
            !this.$baseData.judgeStringIsNumber(element.value)
          ) {
            throw { message: element.title + "只能为数字!" };
          }
          // 3.百分比判断
          if (
            element.type == "input-num-precent" &&
            !(element.value >= 0 && element.value <= 100)
          ) {
            throw { message: element.title + "不可超出(0-100)范围!" };
          }
        });
        let requestData = { id: this.id };
        requestData = this.$baseData.array2json(this.list, requestData);
        console.log(
          requestData,
          requestData.examGrade + requestData.practicalGrade
        );
        // 3.理论占比与实操占比加起来为100
        if (
          Number(requestData.examGrade) + Number(requestData.practicalGrade) !=
          100
        ) {
          throw { message: "理论与实操占比之和必须为100%!" };
        }
        let resultData = await this.$request({
          url: "/occupation/saveOrUpdateOccupation",
          method: "post",
          data: requestData,
        });
        return true;
      } catch (error) {
        this.$message.error(error.message);
        return false;
      }
    },
    /**
     * 返回上一层
     */
    goback() {
      this.$confirm(
        "离开页面会丢失当前编辑的内容,是否保存当前编辑的内容?",
        "您即将离开编辑页面",
        {
          confirmButtonText: "保存",
          cancelButtonText: "返回",
          type: "warning",
        }
      )
        .then(async () => {
          // 保存
          let flag = await this.saveWorkLicenseTask();
          if (flag) {
            this.$router.back();
          }
        })
        .catch(() => {
          this.$router.back();
        });
    },
  },
  async mounted() {
    this.id = this.$route.query.id;
    await this.getProfessionalList();
    await this.getListByType();
    await this.reExamList();
    this.list.forEach((element) => {
      if (element.type == "select" || element.type == "select-disable") {
        element.options = this.options[element.key];
      }
    });
    if (this.id != "") {
      await this.initData();
    }
  },
};
</script>

<style lang="less" scoped>
#admin-occupation-edit {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px 15px;
  box-sizing: border-box;
  > .content {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    > .con {
      width: 100%;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      > .line {
        height: auto;
        min-height: 40px;
        display: flex;
        margin-bottom: 20px;
        padding: 0 20px;
        box-sizing: border-box;
        > .title {
          width: 180px;
          height: auto;
          min-height: 30px;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          font-size: 15px;
          margin-right: 5px;
          font-weight: bold;
          > .xx {
            color: #f00;
            font-size: 20px;
            margin-top: 4px;
            margin-right: 8px;
          }
        }
        > .value {
          width: 0;
          flex: 1;
          height: auto;
          margin-right: 50px;
          /deep/ .el-select {
            width: 100%;
          }
        }
      }
      > .style-line-1 {
        width: 100%;
      }
      > .style-line-2 {
        width: 50%;
      }
    }
  }
}
</style>